import { supabase } from '../lib/supabase.js';

/**
 * Cria um lead na tabela `leads`.
 * RLS permite INSERT anônimo.
 *
 * @param {{
 *   nome: string,
 *   telefone: string,
 *   email?: string,
 *   cpf?: string,
 *   data_test_drive?: string,   // ISO date "YYYY-MM-DD"
 *   origem?: string
 * }} leadData
 */
export async function enviarLead(leadData) {
  const { data, error } = await supabase
    .from('leads')
    .insert([leadData])
    .select()
    .single();

  return { data, error };
}

/**
 * Vincula um lead a um veículo via lead_interesses.
 * RLS permite INSERT anônimo.
 */
export async function criarInteresse({ lead_id, veiculo_id, mensagem = '', data_test_drive = null }) {
  const payload = { lead_id, veiculo_id, mensagem };
  if (data_test_drive) payload.data_test_drive = data_test_drive;

  const { data, error } = await supabase
    .from('lead_interesses')
    .insert([payload])
    .select()
    .single();

  return { data, error };
}

/**
 * Registra um lead e seu interesse de forma atômica via Edge Function.
 *
 * @param {{
 *   nome: string,
 *   telefone: string,
 *   email?: string,
 *   cpf?: string,
 *   veiculo_id: string,
 *   data_test_drive?: string,
 *   mensagem?: string,
 *   origem?: string
 * }} payload
 */
export async function registrarLeadPublico(payload) {
  const { data, error } = await supabase.functions.invoke('public-registrar-lead', {
    body: payload
  });

  return { data, error };
}
